import { Injectable } from '@angular/core';
import { UserData } from './Authorization/Models/Models';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AppConfig {
  clientData :String = "PH.Observe.Web";
  userData: UserData;
  dropdownChanged;
  institutions:string;
  institutionID:number;
  viewconsumption:boolean;
  editconsumption:boolean = false;
  showconsumption:boolean
  filterDetails = [];
  siteUrl: string = environment.siteUrl;
  userSubject = new Subject<any>();
  androidUrl=environment.androidUrl;
  iosUrl=environment.iosUrl;
  consumerKey = environment.consumerKey;
  campaigns = [];
  checkId: string;
  checkGeneralFilter: any;
}
